import React from "react";
import * as Models from "../../../Models";
import { downloadExportedFile } from "../../../Api/azure";
import useSearchStore from "../../../Store/search";

interface IExportLinkProps {
    download: Function;
    status: Models.FileExportStatus;
}

export default function DownloadMenu() {
    const downloadsMenuActive = useSearchStore((s) => s.downloadsMenuActive);
    const exportFiles = useSearchStore((s) => s.exportFiles);
    const toggleDownloadsMenu = useSearchStore((s) => s.toggleDownloadsMenu);
    const exportFilesFiltered = Object.keys(exportFiles)
        .map((key) => exportFiles[key])
        .filter((x) => x.visible);
    const getStatusClassName: (status: string) => string = (status: string) => {
        return status.toLowerCase() == "failed"
            ? "DownloadMenu__failed"
            : "DownloadMenu__success";
    };

    const downloadMenuClassName: string = `DownloadMenu ${
        downloadsMenuActive ? "DownloadMenu--active" : ""
    }`;

    let isVisible = (input: Models.FileExport) => input.visible;
    let exportFilesNew: Models.FileExport[];
    if (
        exportFilesFiltered &&
        exportFilesFiltered.filter(isVisible).length > 0
    ) {
        exportFilesNew = exportFilesFiltered.filter(isVisible);
    } else {
        exportFilesNew = [];
    }

    return (
        <div className={downloadMenuClassName}>
            <button
                onClick={() => toggleDownloadsMenu(false)}
                className="btn btn-primary DownloadMenu__closeButton"
            >
                Close
            </button>
            {exportFilesNew.map((file, index) => {
                if (file && file.visible) {
                    return (
                        <div key={file.id}>
                            <div>
                                Export file ({file.id.substr(0, 4)}){" "}
                                <strong
                                    className={getStatusClassName(
                                        Models.FileExportStatus[file.status]
                                    )}
                                >
                                    {Models.FileExportStatus[file.status]}
                                </strong>
                            </div>
                            {file.uri && file.uri != "" && file.status && (
                                <ExportLink
                                    download={() =>
                                        downloadExportedFile(file.id)
                                    }
                                    status={file.status}
                                ></ExportLink>
                            )}
                        </div>
                    );
                }
            })}
        </div>
    );
}

function ExportLink(props: IExportLinkProps): JSX.Element {
    const download = (e: any) => {
        e.preventDefault();
        props.download();
    };

    if (props.status === Models.FileExportStatus.Succeeded) {
        return (
            <div
                className="AdvancedSearch__exportLink"
                onClick={(e) => download(e)}
            >
                <span className="link-text">Download file</span>
            </div>
        );
    }

    return (
        <div className="DownloadMenu__exporting">
            <span className="DownloadMenu__exporting__text">Exporting...</span>
        </div>
    );
}
